import { render, staticRenderFns } from "./ProductTour.vue?vue&type=template&id=1bca6de2&"
import script from "./ProductTour.vue?vue&type=script&lang=ts&"
export * from "./ProductTour.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports